import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductRatingStars.css';

function ProductRatingStars({ productId }) {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRatingSummary();
  }, [productId]);

  const fetchRatingSummary = async () => {
    try {
      const res = await fetch(`/api/ratings/product/${productId}`);
      if (res.ok) {
        const data = await res.json();
        setSummary(data.summary || { count: 0, average: 0 });
      } else {
        setSummary({ count: 0, average: 0 });
      }
    } catch (err) {
      console.error('Error fetching ratings:', err);
      setSummary({ count: 0, average: 0 });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return null;
  }

  const hasRatings = summary && summary.count > 0;

  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(summary.average);
    const hasHalfStar = summary.average % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<span key={`full-${i}`} className="star full">★</span>);
    }
    
    if (hasHalfStar && fullStars < 5) {
      stars.push(<span key="half" className="star half">★</span>);
    }
    
    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<span key={`empty-${i}`} className="star empty">★</span>);
    }

    return stars;
  };

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/product/${productId}/reviews`);
  };

  if (!hasRatings) {
    return (
      <button
        type="button"
        className="rating-cta"
        onClick={handleClick}
        title="Dieses Produkt bewerten"
      >
        Bewerten
      </button>
    );
  }

  return (
    <div 
      className="product-rating-stars" 
      onClick={handleClick}
      title={`${summary.average.toFixed(1)} von 5 Sternen (${summary.count} Bewertungen) - Klicken für Details`}
    >
      <div className="stars-container">
        {renderStars()}
      </div>
      <span className="rating-count">({summary.count})</span>
    </div>
  );
}

export default ProductRatingStars;
